import { FETCH_MORE_PRODUCTS_REQUEST } from './../const';

export default () => {
  return {type: FETCH_MORE_PRODUCTS_REQUEST}
};
